module.exports = __webpack_public_path__ + "static/media/mintic.24ecbb5f.png";